import { useQueryClient } from '@tanstack/react-query';

function MealCard({ meal, onShowDetails, onToggleFavorite, isFavorite }) {
  const queryClient = useQueryClient();

  const handlePrefetch = async () => {
    queryClient.prefetchQuery({
      queryKey: ['mealDetails', meal.idMeal],
      queryFn: async () => {
        const res = await fetch(
          `https://www.themealdb.com/api/json/v1/1/lookup.php?i=${meal.idMeal}`
        );

        if (!res.ok) {
          throw new Error('Failed to load meal details');
        }

        const data = await res.json();
        return data.meals?.[0];
      },
    });
  };

  return (
    <article className="meal-card" onMouseEnter={handlePrefetch}>
      <img src={meal.strMealThumb} alt={meal.strMeal} className="meal-card-image" />
      <div className="meal-card-body">
        <h3>{meal.strMeal}</h3>
        <div className="meal-card-actions">
          <button type="button" onClick={onShowDetails}>
            Details
          </button>
          <button type="button" onClick={() => onToggleFavorite(meal)}>
            {isFavorite ? 'Remove Favorite' : 'Add Favorite'}
          </button>
        </div>
      </div>
    </article>
  );
}

export default MealCard;
